module.exports = __webpack_public_path__ + "img/button_box_down.50450868.png";